import type { IconSvgObject } from './types';

const SendToMobile02Icon: IconSvgObject = [
  ["path", { d: "M19 12.0337H12M17 9L20 12L17 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 18V20.5C17 21.3284 16.3284 22 15.5 22H5.5C4.67157 22 4 21.3284 4 20.5V3.5C4 2.67157 4.67157 2 5.5 2H15.5C16.3284 2 17 2.67157 17 3.5V5.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 2H8.5L9 3H12L12.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SendToMobile02Icon;
